module.exports = __webpack_public_path__ + "img/wax.4cba7932.svg";